import Cleave from 'cleave.js';

export default function phoneMask() {

    /*if ($('.input-phone').length) {

        $('.input-phone').toArray().forEach(function (field) {
            new Cleave(field, {
                numericOnly: true,
                delimiter: '',
                blocks: [2, 0, 3, 3, 2, 2],
                delimiters: ['(', ')', '-', '-']
            });
        });
    }*/
}